import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as fromRootStore from "../../reducers";
import { CommonService } from "../../services/common.service";
import { ExcelService, ReportService } from "../../services/index";
declare var google;

@Component({
  selector: "overAllStockReport",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./overAllStockReport.html",
})
export class overAllStockReport implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  seasonList = [];
  typeList = ["Wholesale", "Retail", "Estimate"];
  gridOptions: any;
  designnoList = [];
  dataList = [];
  qualityList: any;
  colorList = [
    "lightgoldenrodyellow",
    "rgb(240 249 249)",
    "bisque",
    "lightcyan",
    "rgb(243 228 247)",
    "rgb(249 245 235)",
    "#f9e2e2",
    "#efe7ef",
    "#ddf7dd",
    "gb(229 225 223)"
  ];
 
  codeList: any;
  fitList = [];
  styleList = [];
  widthList: any[];
  brandList: any[];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  finyearList = [];
  exceldata: any;
  groupbyList = ["DESIGN NO", "WO NO"];
  filter: any = {
    type1: "",
    brand: "",
    style: "",
    fit: "",
    design_no: "",
    stock_type: "",
    type: "",
    party_id: "",
    groupby: "overAllStock",
    color: ""
  };
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "wo_no",
    orderDir: "asc",
  };
  printConfig: any = {
    title: "WorkOrder Report",
    columns: [],
    rows: [],
  };

  partyList = [];

  // @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
  // @ViewChild('nameTemplate') nameTemplate: TemplateRef<any>;
  // @ViewChild('addrTemplate') addrTemplate: TemplateRef<any>;
  //   @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  //   @ViewChild('partyDataTable') partyDataTable;
  columns = [];
  totalList = {
    tot_mtrs: 0,
    tot_pcs: 0,
    tot_cost: 0,
  };
  partycodeList = [];
  toggleCol = [];
  menu: any;
  reportTypeList = ["DESIGN NO", "PARTY", "PURCHASE"];
  reportName = "design_no";
  reportType = "Design";
  filterExpand = false;
  stockList = [];
  filterData: any;
  agentList$ = [];
  swatchList = ["YES", "NO"];
  sampList = ["YES", "NO"];
  visible: string;
  user: any;
  shown: boolean = false;
  agentVisible: boolean = false;
  companyInfo: any = [];
  orderList: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    private commonserv: CommonService,
    private excelService: ExcelService,
    public datePipe: DatePipe,
    private reportService: ReportService,
    public toasterService: ToasterService
  ) { }

  ngOnInit(): void {
    this.visible = this.menu.param;
    if (this.visible == "notvisible") {
      this.shown = true;
    }
    this.stockReport();
    this.brandlist();
  }

  stockReport() {
    this.filter.valueshown = this.menu.param;
    let params = {
      filter: this.filter,
    };
    let that = this;
    this.reportService.overAllStockReport(params).then(function (res: any) {
      that.stockList = res.data;
      that.stockList.forEach((el) => {
        that.totalList.tot_cost += Number(el.cost);
        that.totalList.tot_mtrs += Number(el.mtrs);
        that.totalList.tot_pcs += Number(el.tot_pcs);
      });

      that.totalList.tot_cost = Number(that.totalList.tot_cost.toFixed(2));
      that.totalList.tot_mtrs = Number(that.totalList.tot_mtrs.toFixed(2));
      that.totalList.tot_pcs = Number(that.totalList.tot_pcs.toFixed(2));
      that.totalList.tot_cost = that.moneyFormat(that.totalList.tot_cost);

      that.stockList[0].background = "lightcyan";
      that.stockList[1].background = "bisque";
      that.stockList[2].background = "lightblue";
      that.stockList[3].background = "lightgoldenrodyellow";
      that.stockList[4].background = "thistle";
      that.stockList[5].background = "floralwhite";
      that.stockList[6].background = "#cc97ca";
      that.stockList[7].background = "#f2cd75";
      that.stockList[8].background = "#cec4aa";
      // that.stockList[9].background = "rgb(206, 196, 170)";
      that.stockList[9].background = "lightgrey";
      that.stockList[10].background = "lightsteelblue";


    });
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  brandlist() {
    let data = this.commonserv.itemMaster();
    let brand = data.brand;
    this.brandList = brand;
    this.styleList = data.style;
    this.fitList = data.fit;
    let style = data.style;
  }

  exportToExcel($event) {
    this.excelService.exportAsExcelFile(this.exceldata, this.title);
  }

  nextLevel(params) {
    let stock_type;
    this.filter.valueshown = this.menu.param;
    if (this.filter.groupby == "overAllStock") {
      stock_type = params.stock_type;
      this.filter.stock_type = stock_type;
    } else {
      stock_type = this.filter.stock_type;
    }

    let groupby = this.filter.groupby;
    let type;
    if (
      groupby == "coreNewWise" ||
      groupby == "estimateCoreNew" ||
      groupby == "damageCoreNew" ||
      groupby == "aftAcDesign"
    ) {
      this.filter.type = params.row.type;
      type = this.filter.type;
    }
    if (groupby == "estimateCoreDesign" || groupby == "estimateNewDesign") {
      this.filter.party_id = params.row.party_id;
    }

    //    if(stock_type=='SHIRT STOCK'){
    //        if(groupby=='coreDesignWise'){
    //            this.filter.design_no = params.row.design_no;
    //            this.filter.groupby="coreShadeWise";
    //        }
    //        if(groupby=="newDesignWise"){
    //         this.filter.design_no = params.row.design_no;
    //            this.filter.groupby="newShadeWise";
    //        }
    //         if(groupby=='coreNewWise'){
    //               if(type=='CORE'){
    //                   this.filter.groupby="coreDesignWise";
    //               }
    //               if(type=='NEW'){
    //                 this.filter.groupby="newDesignWise";
    //             }
    //         }
    //        if(groupby=='overAllStock'){
    //            this.filter.groupby="coreNewWise";
    //        }
    //    }
    if (stock_type == "SHIRT STOCK") {
      if (groupby == "gangDesignWise") {
        this.filter.design_no = params.row.design_no;
        this.filter.groupby = "gangShadeWise";
      }
      if (groupby == "plainDesignWise") {
        this.filter.design_no = params.row.design_no;
        this.filter.groupby = "plainShadeWise";
      }
      if (groupby == "coreDesignWise") {
        this.filter.design_no = params.row.design_no;
        this.filter.groupby = "coreShadeWise";
      }
      if (groupby == "newDesignWise") {
        this.filter.design_no = params.row.design_no;
        this.filter.groupby = "newShadeWise";
      }
      if (groupby == "beforeAfter90New") {
        this.filter.duration = params.row.duration;
        this.filter.groupby = "newDesignWise";
      }
      if (groupby == "coreNewWise") {
        if (type == "CORE") {
          this.filter.groupby = "coreDesignWise";
        }
        if (type == "NEW") {
          this.filter.groupby = "newDesignPcs";
        }
        if (type == "GANG") {
          this.filter.groupby = "gangDesignWise";
        }
        if (type == "PLAIN") {
          this.filter.groupby = "plainDesignWise";
        }
      }
      if (groupby == "overAllStock") {
        this.filter.groupby = "coreNewWise";
      }
    }

    if (stock_type == "COMBO STOCK") {
      if (groupby == "overAllStock") {
        this.filter.groupby = "comboStyleStock";
      } else if (groupby == "comboStyleStock") {
        this.filter.groupby = "comboDesignStock";
        this.filter.style = params.row.type;
      } else if (groupby == "comboDesignStock") {
        this.filter.groupby = "comboColorStock";
        this.filter.design_no = params.row.design_no;
      }
    }

    if (stock_type == "DHOTI STOCK") {
      if (groupby == "overAllStock") {
        this.filter.groupby = "dhotiDesignStock";
      } else if (groupby == "dhotiDesignStock") {
        this.filter.groupby = "dhotiColorStock";
        this.filter.design_no = params.row.design_no;
      } else if (groupby == "dhotiColorStock") {
        this.filter.groupby = "dhotiBarcodeStock";
        this.filter.color = params.row.color;
      }
    }

    if (stock_type == "ESTIMATE STOCK") {
      if (groupby == "estimateCoreNewDesign") {
        this.filter.design_no = params.row.design_no;
        this.filter.party_id = params.row.party_id;
        this.filter.groupbyList = "estimateCoreNewShade";
      }

      if (groupby == "overAllStock") {
        this.filter.groupby = "estimateCoreNewDesign";
      }
    }

    if (stock_type == "BEF.AC CUTTING STOCK") {
      if (groupby == "befAcDesign") {
        this.filter.design_no = params.row.design_no;
        this.filter.groupby = "befAcShade";
      }
      if (groupby == "overAllStock") {
        this.filter.groupby = "befAcDesign";
      }
    }

    if (stock_type == "AFT.AC CUTTING STOCK") {
      //     if(groupby=='overAllStock'){
      //         this.filter.groupby = 'aftAcDesign';
      //     }
      //     if(groupby=='aftAcDesign'){
      //         groupby = 'withoutdgrn';
      //         if(groupby == 'withoutdgrn'){
      //             this.filter.design_no = params.row.design_no;
      //             this.filter.groupby="withdesign";
      //         }

      //   }
      if (groupby == "aftAcDesign") {
        this.filter.design_no = params.row.design_no;
        this.filter.wo_no = params.row.wo_no;
        this.filter.groupby = "aftAcShade";
      }
      if (groupby == "overAllStock") {
        this.filter.groupby = "aftAcDesign";
      }
    }
    if (stock_type == "RGRN STICKER PENDING") {
      this.filter.groupby = "withdgrn";
      if (groupby == "withdgrn") {
        this.filter.design_no = params.row.design_no;
        this.filter.groupby = "withdesign";
      }
    }

    if (stock_type == "TEXTILE STOCK") {
      if (groupby == "textileDesign") {
        this.filter.design_no = params.row.design_no;
        this.filter.groupby = "textileShade";
      }
      if (groupby == "text_type") {
        this.filter.duration = params.row.categery;
        this.filter.groupby = "textileDesign";
      }
      if (groupby == "overAllStock") {
        this.filter.groupby = "text_type";
      }
    }

    if (stock_type == "DAMAGE STOCK") {
      if (groupby == "damageCoreDesign") {
        this.filter.design_no = params.row.design_no;
        this.filter.groupby = "damageCoreShade";
      }
      if (groupby == "damageNewDesign") {
        this.filter.design_no = params.row.design_no;
        this.filter.groupby = "damageNewShade";
      }
      if (groupby == "damageGangDesign") {
        this.filter.design_no = params.row.design_no;
        this.filter.groupby = "damageGangShade";
      }

      if (groupby == "damageCoreNew") {
        if (type == "CORE") {
          this.filter.groupby = "damageCoreDesign";
        }
        if (type == "NEW") {
          this.filter.groupby = "damageNewDesign";
        }
        if (type == "GANG") {
          this.filter.groupby = "damageGangDesign";
        }
      }
      if (groupby == "overAllStock") {
        this.filter.groupby = "damageCoreNew";
      }
    }

    if (stock_type == "LR STOCK") {
      if (groupby == "invDesign") {
        this.filter.design_no = params.row.design_no;
        this.filter.groupby = "invShade";
      }
      if (groupby == "overAllStock") {
        this.filter.groupby = "invDesign";
      }
    }

    if (stock_type == "BUNDLE STOCK") {
      if (groupby == "bundleDesign") {
        this.filter.design_no = params.row.design_no;
        this.filter.groupby = "bundleShade";
      }
      if (groupby == "overAllStock") {
        this.filter.groupby = "bundleDesign";
      }
    }

    if (stock_type == "COUNTER STOCK") {
    
      if (groupby == "overAllStock") {
        this.filter.groupby = "teamwise";
      }
      else if (groupby == "teamwise") {
        this.filter.incharger = params.row.incharger;
        this.filter.groupby = "agentwise";
      }
      else if (groupby == "agentwise") {
        this.filter.agent_id = params.row.agent_id;
        this.filter.agent_name = params.row.agent_name;
        this.filter.groupby = "partywise";
      }

      else if (groupby == "partywise") {
        this.filter.party_id = params.row.party_id;
        this.filter.party_name = params.row.party_name;
        this.filter.groupby = "dcwise";
      }
      else if (groupby == "dcwise") {
        this.filter.dcid = params.row.dcid;
        this.filter.dc_no = params.row.dc_no;
        this.filter.groupby = "designwise";
      }
    }

    if (stock_type == "LIMIT STOCK" || stock_type == "SIZEWISE STOCK") {
    
      if (groupby == "overAllStock") {
        this.filter.groupby = "style";
      }
      else if (groupby == "style") {
        this.filter.style = params.row.style;
        this.filter.groupby = "type";
      }
      else if (groupby == "type") {
        this.filter.type = params.row.type;
        this.filter.groupby = "design";
      }
    }

    this.getReport();
  }

  onbackbutton() {
    // if(this.filter.groupby=='coreNewWise' || this.filter.groupby=="estimateCoreNew" || this.filter.groupby=='damageCoreNew' || this.filter.groupby=="textileDesign" || this.filter.groupby=="befAcDesign" || this.filter.groupby=="aftAcDesign"){
    //     this.filter.groupby = 'overAllStock';
    // }
    this.filter.groupby = "overAllStock";
    this.filter.stock_type = "";
    this.filter.party_id = "";
    this.filter.design_no = "";
    this.filter.duration = "";
    this.filter.invoiceno = "";
    this.filter.incharger = "";
    this.filter.type = "";
    this.getReport();
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getReport();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    // this.getSalesinvReport();
  }

  onCellClick(event) {
    this.filter.design_no = event.row.design_no;
    if (this.filter.groupby == "overAllStock") {
      this.filter.groupby = "overAllStock";
    }
    this.getReport();
  }

  applyFilter(): void {
    this.filter.party_id = "";
    this.filter.groupby = "overAllStock";
    this.filter.invoiceno = "";
    this.getReport();
  }

  moneyFormat(nStr) {
    // if (nStr == null || nStr == undefined || nStr == '' || nStr == 0)
    //   return 0.00;
    // const no = parseFloat(nStr).toFixed(2);
    // /*if (no < 0) {
    //     nStr = no * -1;
    // }
    // nStr += '';*/

    // const x = no.split('.');
    // let x1 = x[0];
    // const x2 = x.length > 1 ? '.' + x[1] : '';
    // let rgx = /(\d+)(\d{3})/;
    // let z = 0;
    // const len = (x1).length;
    // const num = ((len / 2) - 1);
    // let newval = Math.floor(num);

    // while (rgx.test(x1)) {
    //   if (z > 0) {
    //     x1 = x1.replace(rgx, '$1' + ',' + '$2');
    //   } else {
    //     x1 = x1.replace(rgx, '$1' + ',' + '$2');
    //     rgx = /(\d+)(\d{2})/;
    //   }
    //   z++;
    //   newval--;
    //   if (newval == 0) {
    //     break;
    //   }
    // }

    // let out = x1 + x2;
    // if (Number(no) < 0) {
    //   out = '(' + out + ')';
    // }
    // return Number(out);

    var n1, n2;
    nStr = nStr + "" || "";
    // works for integer and floating as well
    n1 = nStr.split(".");
    n2 = n1[1] || null;
    n1 = n1[0].replace(/(\d)(?=(\d\d)+\d$)/g, "$1,");
    nStr = n2 ? n1 + "." + n2 : n1;
    return nStr;
  }
  getReport(): void {
    let params = {
      filter: JSON.stringify(this.filter),
    };
    let that = this;
    that.gridOptions = {
      loading: true,
      columns: [],
    };
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.reportService
      .nextLevelStock(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.orderList = res.data;
        let temp = 0;
        that.orderList.forEach((el, ind) => {
          if (ind >= 10) {
            temp = temp + 1;
            if (temp == 10) {
             temp = 0;
            }
            el.background = that.colorList[temp];
          }
          else {  
            el.background = that.colorList[ind];
          }
        });
        that.gridOptions = {
          cols: res.cols,
          columns: res.columns,
          data: res.data,
          loading: false,
        };
        // let menuObj = {
        //     cellClass: "txtCenter",
        //     name: "PCS%",
        //     prop: "percent",

        //     width: "90"
        //    }
        //    let menuObj1 = {
        //     cellClass: "txtCenter",
        //     name: "VAL%",
        //     prop: "percent1",

        //     width: "90"
        //    }
        //    that.gridOptions.columns.push(menuObj);
        //    that.gridOptions.columns.push(menuObj1);
        //    let arrVal =res.data;
        //    let totalCnt = 0;
        //    let totalCnt1 = 0;

        //    for(var j =0;j<arrVal.length;j++){
        //        let temp = arrVal[j];
        //    totalCnt += parseFloat(temp.tot);
        //    totalCnt1 += parseFloat(temp.totval);
        //    }
        //    for(var k =0;k<arrVal.length;k++){
        //     let temp1 = arrVal[k];
        //   let  percent:any;
        //   let  percent1:any;
        //   percent =((temp1.tot/totalCnt)*100).toFixed(2);
        // res.data[k].percent = percent;
        // percent1 =((temp1.totval/totalCnt1)*100).toFixed(2);
        // res.data[k].percent1 = percent1;
        // }
        that.exceldata = that.getData(res.columns, res.data);
      });
  }

  getData(columns, data) {
    let cols = columns;
    let value = data;
    let rows = [],
      row,
      ind,
      type,
      val,
      rlen = data.length,
      clen = columns.length;

    for (let i = 0; i < data.length; i++) {
      let sno = i + 1;
      row = Object.assign({}, data[i]);
      let newrow = {
        Sno: sno,
      };
      for (let j = 1; j < clen; j++) {
        let type = cols[j].type,
          index = cols[j].index,
          prop = cols[j].prop,
          name = cols[j].name;

        newrow[name] = row[prop];
      }

      rows.push(newrow);
      sno++;
    }
    return rows;
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  refreshData() {
    let columns = this.columns,
      data = this.dataList,
      row = this.getSummaryRow(data, columns);
    data.push(row);
    this.page.count = data.length;
    // this.dataList = data;
  }

  getSummaryRow(data, columns) {
    let row = {
      type: "summary",
    };
    for (let i = 0; i < columns.length; i++) {
      let col = columns[i];
      switch (col.summary) {
        case "sum":
          let total = 0;
          for (let j = 0; j < data.length; j++) {
            let dat = data[j];
            total += dat[col.prop];
          }
          row[col.prop] = Math.round(total * 100) / 100;
          break;
        default:
          row[col.prop] = "";
          break;
      }
    }
    return row;
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/salesReports/overAllStockReport.ts